import { motion } from "framer-motion";
import { Container } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, NavLink, useLocation } from "react-router-dom";
import "../assets/css/navbar.css";
import VooshLogo from "../assets/images/VooshLogo.webp";
import { container } from "../pages/homepage/Section1";
import Bilal_img from "../assets/images/partner/Bilal_image.webp";
import OloLogo from "../assets/images/partner/logo-Olo-blue.svg";
import { IconX } from "@tabler/icons-react";

const PartnerNavbar = () => {
  const location = useLocation();
  return (
    <Navbar expand="lg" className="Header bg-white" fixed="top">
      <Container className="navbar_container">
        <Navbar.Brand className="d-flex align-items-center">
          {["/partner", "/referrals"].includes(location.pathname) ? (
            <>
              <NavLink
                onClick={() =>
                  window.scrollTo({ top: "0", left: "0", behavior: "smooth" })
                }
                to="/"
              >
                <motion.img
                  width="113"
                  height="56"
                  variants={container}
                  whileInView="visible"
                  initial="hidden"
                  alt="logo"
                  src={VooshLogo}
                  className="d-inline-block align-top voosh_logo"
                />{" "}
              </NavLink>
            </>
          ) : (
            <>
              <NavLink
                onClick={() =>
                  window.scrollTo({ top: "0", left: "0", behavior: "smooth" })
                }
                to="/"
              >
                <motion.img
                  width="113"
                  variants={container}
                  whileInView="visible"
                  initial="hidden"
                  alt="logo"
                  src={VooshLogo}
                  className="d-inline-block align-top partner-v-logo"
                />{" "}
              </NavLink>
              <IconX stroke={3} />
              <NavLink
                onClick={() =>
                  window.scrollTo({ top: "0", left: "0", behavior: "smooth" })
                }
                to="https://www.olo.com/"
                target="_blank"
              >
                <motion.img
                  width="80"
                  variants={container}
                  whileInView="visible"
                  initial="hidden"
                  alt="logo"
                  src={OloLogo}
                  className="d-inline-block align-top px-0 py-2 partner-olo-logo"
                />{" "}
              </NavLink>
            </>
          )}
        </Navbar.Brand>
        <Nav
          as={motion.div}
          variants={container}
          whileInView="visible"
          initial="hidden"
        >
          {["/partner", "/referrals"].includes(location.pathname) &&
            (location.pathname === "/referrals" ? (
              <Link
                className="book_demo_btn rounded-pill mb-0 hide-in-mv"
                style={{ backgroundColor: "#f36513", fontWeight: "600" }}
                to="/partner"
              >
                Partners
              </Link>
            ) : (
              <Link
                className="book_demo_btn rounded-pill mb-0 hide-in-mv"
                style={{ backgroundColor: "#f36513", fontWeight: "600" }}
                to="/referrals"
              >
                Referrals
              </Link>
            ))}

          <Link
            to={"https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal"}
            className="btn btn-dark text-white rounded-pill nav_book_a_call"
          >
            <img className="rounded-pill" src={Bilal_img} alt="Bilal profile" />
            <span className="animate__animated animate__pulse animate__infinite"></span>{" "}
            Book a Call
          </Link>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default PartnerNavbar;
